export default __webpack_public_path__ + "static/media/487.d7e2b984.gif";